export const CONTACT = {
  INFO: 'info@sejfa.nu'
} as const;

export const SOCIAL_MEDIA = {
  INSTAGRAM: 'https://instagram.com/sejfa.nu?igshid=MzRlODBiNWFlZA=='
} as const;
